import { render } from "./comaside.vue?vue&type=template&id=5656381e&scoped=true"
const script = {}

import "./comaside.vue?vue&type=style&index=0&id=5656381e&scoped=true&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5656381e"]])

export default __exports__